import { createContext } from 'react';
import { Contexts } from '../utils/types';

const AppContext: Contexts.App = {
    refs: {
        prevField: null,
        currentField: null,
        nextField: null,
    },
    isValid: false,
    isFocused: false,
    isLoading: false,
    isScrollable: false,
    toggleFocus: () => {},
    toggleLoading: () => {},
    toggleScroll: () => {},
    toggleValid: () => {},
};  

export default createContext( AppContext );    